module.exports = __webpack_public_path__ + "img/spectrum-css-icons.72938e79.svg";